import React, { useEffect } from 'react';
import { installMetaPixel } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Catalog } from './components/catalog/Catalog';
import { WhatWeDo } from './components/WhatWeDo';
import { Benefits } from './components/Benefits';
import { WhyUs } from './components/WhyUs';
import { CTA } from './components/CTA';
import { Philosophy } from './components/Philosophy';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    installMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="31aqf2ee30qq7">
      <Header data-id="element-1" data-mp="31cjmvx0flgzs" />
      <main data-id="element-2" data-mp="2wk0av4he6tx3">
        <Hero data-id="element-3" data-mp="2wjgrdjc3fxgy" />
        <Catalog data-id="element-4" data-mp="2wjqkvgwckmre" />
        <WhatWeDo data-id="element-5" data-mp="2wj8fnurpiy7c" />
        <Benefits data-id="element-6" data-mp="2whx9joashed2" />
        <WhyUs data-id="element-7" data-mp="28ufp6dtutik4" />
        <CTA data-id="element-8" data-mp="28u5vaf5our95" />
        <Philosophy data-id="element-9" data-mp="28tmdqzjya4vn" />
      </main>
      <Footer data-id="element-10" data-mp="28sl32w6ujkeg" />
    </div>;
}